export default __webpack_public_path__ + "static/media/mission_superhelden.164e8e34.mp3";